<h1 class="instruction-title text-center">{{'welcome_to_youca' | translate}}</h1>

<p class="text-center"><i>{{'youca_name_long' | translate}}</i></p>

<p>{{'youca_info_1' | translate}}</p>
<p>{{'youca_info_2' | translate}}</p>

<h2 class="instruction-title">{{'before_you_start' | translate}}</h2>

<p>{{'before_you_start_info_1' | translate}}</p>
<p>{{'before_you_start_info_2' | translate}}</p>
<p>{{'before_you_start_info_3' | translate}}</p>
